export default __webpack_public_path__ + "images/18aa8fc35501e1c59d8b16b94ea2ad8c-valentine_dsrp_tablet.webp";